import { Position, State } from 'src/types'
import { flatWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/flatWeb'
import { crossJointWeb, crossWeb, crossWebCenterStitch } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/crossWeb'
import { onePeaceWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/onPeaceWeb'
import { vWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/vWeb'
import { laceOfcrossWebWithHalfNet, laceOfNetWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/netWeb'
import { netWeb2 } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/netWeb2'
import { laceOfNetWebDouble, netWebDouble } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/netWebDouble'
import { crossDoubleWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/crossDoubleWeb'
import { basketForPitcherWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/basketWeb'
import { hJointWeb, hWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/hWeb'
import {
  underWeb,
  underWebForNetWeb1,
  underWebForNetWeb2,
  underWebReinforcement
} from 'src/features/brands/atoms/canvas/rightThrow/glove/front/lace/underWeb'
import { fenceWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/fenceWeb'
import { crossWebWithHalfNetLace } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/crossWebWithHalfLaceWeb'
import { jointCheckerWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/jointCheckerWeb'
import { netVWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/netVWeb'
import { lacingNetWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/lacingNetWeb'
import { lacingCrownNetWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/lacingCrownNetWeb'
import { hWeb2 } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/hWeb2'
import { onePeaceWeb2 } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/onePeaceWeb2'
import { laceOfNetWeb2, lacingWeb1 } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/lacingWeb1'
import { laceOfNetWebDoubleWithJoint } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/newWebDoubleWithJoint'
import { indexWrapBack } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/lace/connectIndexToWeb'
import { twoPeaceVDesignWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/twoPeaceVDesignWeb'
import { w1Web } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/w1Web'
import { w2Web } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/w2Web'
import { flatVLaceWeb } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/flatVLaceWeb'
import { netWeb3 } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/netWeb3'
import { w34Web } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/web/w34Web'
import { w36Web, w36WebCrossLace } from './w36Web'
import { w32Web } from './w32Web'
import { reinforcementLaceModel } from 'src/features/brands/atoms/japan/constants/baseModel'
import { webDrawUtil } from 'src/features/brands/util/canvas'
import { w37Web } from './w37Web'
import { w38Web } from './w38Web'
import { w31Web } from './w31Web'

export const webOfGloveFrontDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor } = webDrawUtil(state)
  if (webMatcher(['w1'])) w1Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w2'])) w2Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w3', 'w35'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w4'])) flatVLaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w5'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w6', 'w22', 'w29'])) crossWebCenterStitch(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w7'])) onePeaceWeb2(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w8', 'w10'])) crossWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w9'])) hWeb2(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w11'])) hWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w12'])) lacingCrownNetWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w13'])) lacingNetWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w14'])) netWeb3(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w16'])) lacingWeb1(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['w17'])) netWeb2(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w18'])) twoPeaceVDesignWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w19'])) crossDoubleWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w20'])) netVWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w21'])) crossWebWithHalfNetLace(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w23'])) fenceWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w24'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w25'])) netWebDouble(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w26'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['w27'])) hJointWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w28'])) crossJointWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w30'])) vWeb(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w31'])) w31Web(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w32'])) w32Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w15', 'w33'])) netWebDouble(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w34'])) w34Web(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w36'])) w36Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w37'])) w37Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w38'])) w38Web(ctx, webColor, laceColor, stitchColor)
}

export const rightLaceOfNetWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, productNumber } = webDrawUtil(state)
  if (webMatcher(['w14', 'w17'])) {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
  }
  if (webMatcher(['w14', 'w17', 'w20'])) laceOfNetWeb(ctx, laceColor)
  if (webMatcher(['w15', 'w33'])) laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w16'])) laceOfNetWeb2(ctx, laceColor)
  if (webMatcher(['w21'])) laceOfcrossWebWithHalfNet(ctx, laceColor)
  if (webMatcher(['w25'])) laceOfNetWebDoubleWithJoint(ctx, laceColor, stitchColor, webColor, web2Color)

  if (webMatcher(['w15', 'w25', 'w33', 'w36'])) {
    underWebForNetWeb1(ctx, laceColor, 0, 0)
    underWebForNetWeb1(ctx, laceColor, -17, 30)
    underWebForNetWeb2(ctx, laceColor, -133, 95, -20)
    underWebForNetWeb2(ctx, laceColor, -15, 28, 0)
  }

  if (webMatcher(['w6', 'w8', 'w9', 'w10', 'w11', 'w19', 'w20', 'w22', 'w24', 'w27', 'w28', 'w29', 'w30', 'w31', 'w32', 'w34'])) {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
  if (webMatcher(['w23'])) {
    underWeb(ctx, laceColor, 27, -24) // ウェブ下＿右
    underWeb(ctx, laceColor, -2, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -35, 72) // ウェブ下＿左

    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, 0, 0) // 下
  }
  if (webMatcher(['w1', 'w2', 'w3', 'w4', 'w5', 'w13', 'w26', 'w35', 'w37', 'w38'])) {
    underWeb(ctx, laceColor, 27, -24) // ウェブ下＿右
    underWeb(ctx, laceColor, -2, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -35, 72) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, -4, -40) // 中
    indexWrapBack(ctx, laceColor, 3, 20) // 下
  }

  if (webMatcher(['w18'])) {
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, -4, -40) // 中
    indexWrapBack(ctx, laceColor, 3, 20) // 下
    underWeb(ctx, laceColor, 17, -10) // ウェブ下＿右
    underWeb(ctx, laceColor, -5, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -28, 65) // ウェブ下＿左
  }

  if (webMatcher(['w36'])) {
    laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
    w36WebCrossLace(ctx, laceColor)
  }
  if (reinforcementLaceModel.includes(productNumber) && !webMatcher(['w13', 'w14', 'w25', 'w26', 'w36'])) underWebReinforcement(ctx, laceColor)
  if (webMatcher(['w28', 'w29', 'w30', 'w31', 'w34'])) underWebReinforcement(ctx, laceColor)
}
